import axios from "axios"
import apiConfig from "../../apiConfig/apiConfig";
const baseUri = apiConfig.api.baseURL;
// console.log("Base URI for payment validation:", baseUri);
// const testUri="http://localhost:3009/api/v1/order/verify"
export const paymentValidation=async(payload)=>{
    try{
        const res=await axios.post(`${baseUri}/payment/api/v1/order/verify`,payload);
        // const res=await axios.post(`${testUri}`,payload);
        return res
    }catch(e){
        throw e;
    }
}